/*global window, jQuery, puntocasa */
(function($) {

  'use strict';

  $(function() {

    $('.selectpicker').selectpicker({
      style: 'btn-info',
      size: 4
    });

    $('[data-toggle="tooltip"]').tooltip({html: true});

    const getModalActionButton = (button) =>
    `<button type="button" class="btn btn-default"
        id="modal-action-${button.id}">
      ${button.text}
    </button>`;

  const getModalDismissButton = (button) =>
    `<button type="button" class="btn btn-default" data-dismiss="modal">
      ${button.text}
    </button>`;

    const addModalButton = ($container, button) => {
      const $button = $(button.dismiss || !button.action ?
          getModalDismissButton(button) : getModalActionButton(button));
      $container.append($button);
      if (button.action) {
        $button.on('click', button.action);
      }
    };

    const showModal = function(message, buttons) {
      const $modal = $('.modal');
      const $modalFooter = $modal.find('.modal-footer');

      $('.modal-body').hide().html(message).show();

      if (!$modal.hasClass('in')) {
        $modal.modal('show');
      }

      $modalFooter.html('');

      if (buttons && buttons.length > 0) {
        $.each(buttons, function(index, button) {
          addModalButton($modalFooter, button);
        });
      }

      return $modal;
    };

    const showAjaxModal = (url, buttons, data, callback) => {
      data = data || {};
      $.ajax({url, data}).done((template) => {
        const $modal = showModal(template, buttons);
        if (callback) {
          callback($modal);
        }
      });
    };

    const getPopupContent = (title, message, icon, type) => '<div class="popup-step"> <span class="glyphicon glyphicon-${icon} popup-icon popup-icon-${type}"></span> <h3>${title}</h3> <p>${message}</p></div>';


    const validate = ($form) => {
      $form.validate({
        invalidHandler: function(event, validator) {
          $('input', $form).removeClass('form-error');
          for (let index = 0; index < validator.errorList.lenght; index++) {
            const error = validator.errorList[index];
            $(error.element).addClass('form-error');
          }
        },
        errorPlacement: () => false
      });
    };

    const showResetPassword = () => {
      const buttons = [
        {
          text: puntocasa.texts.chiudi
        },
        {
          text: 'Invia',
          class: 'login-form-button',
          action: () => $('#resetForm').submit()
        }
      ];
      const onPopupLoad = () => validate($('#resetForm'));
      const templateURL = 'templates/popup-reset-password.page.php';
      showAjaxModal(templateURL, buttons, false, onPopupLoad);
    };

    const showLogin = () => {

      const buttons = [
        {
          text: puntocasa.texts.chiudi
        },
        {
          text: 'Accedi',
          class: 'login-form-button',
          action: function(form) {
            var form = $('#loginForm');
            const user = form.find('input[name=user]').val();
            const password = form.find('input[name=password]').val();
            const {language} = puntocasa;

            if ($('#loginForm').valid()) {
              $.ajax({
                url: '/areariservata/ajax/account-login.php',
                type: 'post',
                dataType: 'json',
                data: {user, password, language}
              })
              .done(function(result) {
                if (result.error) {
                  showAjaxModal('templates/popup-error.page.php',
                    [{text: puntocasa.texts.chiudi}],
                    {message: puntocasa.texts.loginError}, ($modal) => {
                      $modal.one('hide.bs.modal', () => {
                        location.href = puntocasa.baseURL;
                      });
                  });
                } else {
                  location.href = puntocasa.loginRedirectUrl;
                }
              })
              .fail(function() {
                console.log('error');
              })
              .always(function() {
                console.log('complete');
              });
            }
          }
        }
      ];
      const onPopupLoad = () => {
        validate($('#loginForm'));
        $('#resetPassword').on('click', showResetPassword);
      };
      const templateURL = 'templates/popup-login.page.php';
      showAjaxModal(templateURL, buttons, false, onPopupLoad);
    };

    $('.loginButton').on('click', function() {
      showLogin();
      return false;
    });

    showLogin();

    if (puntocasa.loginError) {
      showAjaxModal('templates/popup-error.page.php',
        [{text: puntocasa.texts.chiudi}],
        {message: puntocasa.texts.loginError}, ($modal) => {
          $modal.one('hide.bs.modal', () => {
            location.href = puntocasa.baseURL;
          });
        });
    }

  window.puntocasa = window.puntocasa || {};

});

}(jQuery));
